import { BaseApiService } from '@/api/base';
import type {
  BcAttempt,
  BcPhoneNumber,
  ScoringInterrogationAttempt,
  ScoringState,
} from '../types/scoring';

class ScoringApiService extends BaseApiService {
  async getScoringState(): Promise<ScoringState> {
    return this.get<ScoringState>('/scoring/state');
  }

  async initiateScoreObtaining(): Promise<ScoringInterrogationAttempt> {
    return this.post<ScoringInterrogationAttempt>(
      '/scoring/initiate-score-obtaining'
    );
  }

  async getBcPhones(): Promise<BcPhoneNumber[]> {
    return this.get<BcPhoneNumber[]>('/onboarding/bc-phones');
  }

  // Also used to resend: the backend has no separate resend endpoint.
  async sendVerificationCode(phoneId: string): Promise<BcAttempt> {
    return this.post<BcAttempt>(`/scoring/send-verification-code/${phoneId}`);
  }

  async generateByCode(code: string): Promise<BcAttempt> {
    return this.post<BcAttempt>(`/scoring/generate-by-code/${code}`);
  }
}

export const scoringApiService = new ScoringApiService();
